<template>
	<div class="talent-hire">
		<div class="talent">
			<div class="con">
				<div class="con-left">
					<p>
						<span @click="handleNavClick('/walkInto')">走进联丰</span>
						<span class="red">/人才招聘</span>
					</p>
					<p class="title">人才招聘</p>
					<p>联丰典当成立于2005年，是一家经国家商务部批准的专业典当服务机构</p>
				</div>
				<div class="con-right">
					<ApplyForm :title="title" :titleEngLish="titleEngLish" :clueType="clueType" @dialogFun="dialogFun"></ApplyForm>
				</div>
			</div>
		</div>
		<Dialog :centerDialogVisible="centerDialogVisible" @close="close"></Dialog>
	</div>
</template>

<script>
	import ApplyForm from '../components/ApplyForm.vue'
	import Dialog from '../components/Dialog.vue'
	export default {
		components: {ApplyForm,Dialog},
		data() {
			return {
				title: "人才招聘申请",
				titleEngLish: 'RECRUITMENT',
				clueType: 3,
				centerDialogVisible: false,
			}
		},
		mounted() {
			this.sliders = [{
					img: require("../../static/hire/banner.png")
				}],
			// 首次加載時，初始化高度
			this.screeWith = window.innerWidth
			this.bannerHeight = 560 / 1920 * this.screeWith
			// 窗口大小發生變化
			window.onresize = () => {
				this.screeWith = window.innerWidth
				this.bannerHeight = 560 / 1920 * this.screeWith
			}
		},
		methods: {
			dialogFun(flag) {
				this.centerDialogVisible = flag
			},
			close(flag) {
				this.centerDialogVisible = flag
			},
			handleNavClick(path) {
				this.$router.push({
					path: path
				});
			},
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/view/hire.vue